var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns"},[_c('contribution-card',{attrs:{"linkedProject":_vm.project,"isHalf":true,"recommendationSource":_vm.sourceProjectID,"recommendationType":"leo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }